import { __extends, __makeTemplateObject } from "tslib";
import React from 'react';
import rafSchedule from 'raf-schd';
import styled from 'styled-components';
import { WidthObserver } from '../WidthObserver';
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints["S"] = "S";
    Breakpoints["M"] = "M";
    Breakpoints["L"] = "L";
})(Breakpoints || (Breakpoints = {}));
var MAX_S = 1266;
var MAX_M = 2146;
var SCROLLBAR_WIDTH = 30;
export function getBreakpoint(width) {
    if (width === void 0) { width = 0; }
    if (width >= MAX_S && width < MAX_M) {
        return Breakpoints.M;
    }
    else if (width >= MAX_M) {
        return Breakpoints.L;
    }
    return Breakpoints.S;
}
export function createWidthContext(width) {
    if (width === void 0) { width = 0; }
    return { width: width, breakpoint: getBreakpoint(width) };
}
var _a = React.createContext(createWidthContext()), Provider = _a.Provider, Consumer = _a.Consumer;
var RelativeContainer = React.memo(styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"]))));
var WidthProvider = /** @class */ (function (_super) {
    __extends(WidthProvider, _super);
    function WidthProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { width: 0 };
        _this.setWidth = rafSchedule(function (width) {
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(_this.state.width - width) < SCROLLBAR_WIDTH) {
                return;
            }
            _this.setState({ width: width });
        });
        _this.state.width = document.body.offsetWidth;
        return _this;
    }
    WidthProvider.prototype.render = function () {
        return (React.createElement(RelativeContainer, { className: this.props.className },
            React.createElement(WidthObserver, { setWidth: this.setWidth }),
            React.createElement(Provider, { value: createWidthContext(this.state.width) }, this.props.children)));
    };
    return WidthProvider;
}(React.Component));
export { WidthProvider };
export { Consumer as WidthConsumer };
var templateObject_1;
//# sourceMappingURL=index.js.map